<template>
  <div class="layout-container">
    <header class="layout-header">
      <div class="header-left">管理后台</div>
      <div class="header-right">
        <el-dropdown @command="handleCommand">
          <span class="user-dropdown">
            {{ username }}
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </header>

    <div class="layout-main">
      <aside class="layout-sidebar">
        <div 
          v-for="item in menuList" 
          :key="item.id"
          :class="['menu-item', { active: activeMenu === item.path }]"
          @click="handleMenuClick(item)"
        >
          <img :src="item.icon" :alt="item.name" class="menu-icon menu-icon-default" />
          <img :src="item.activeIcon" :alt="item.name" class="menu-icon menu-icon-active" aria-hidden="true" />
        </div>
      </aside>

      <main class="layout-content">
        <router-view v-slot="{ Component }">
          <keep-alive exclude="PublishVideo">
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ArrowDown } from "@element-plus/icons-vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { removeToken, getUserName, removeUserName } from "@/utils/auth";

const router = useRouter();
const route = useRoute();

const username = ref("");

const menuList = [
  {
    id: 1,
    name: "发布任务",
    path: "/task/publish",
    icon: require("@/assets/images/icon-1-2.png"),
    activeIcon: require("@/assets/images/icon-1-1.png"),
  },
  {
    id: 2,
    name: "发布视频",
    path: "/video/publish",
    icon: require("@/assets/images/icon-3-2.png"),
    activeIcon: require("@/assets/images/icon-3-1.png"),
  },
];

const activeMenu = computed(() => route.path);

const handleMenuClick = (item) => {
  router.push(item.path);
};

const handleCommand = (command) => {
  if (command === "logout") {
    ElMessageBox.confirm("确定要退出登录吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        removeToken();
        removeUserName();
        ElMessage.success("退出成功");
        router.push("/login");
      })
      .catch(() => {});
  }
};

onMounted(() => {
  username.value = getUserName() || "用户";
});
</script>

<style lang="scss" scoped>
.layout-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-header {
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  z-index: 10;

  .header-left {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .header-right {
    .user-dropdown {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #606266;

      &:hover {
        color: #409eff;
      }
    }
  }
}

.layout-main {
  flex: 1;
  display: flex;
  background: #f6f6f6;
}

.layout-sidebar {
  width: 130px;
  flex: 0 0 130px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: transparent;
  align-items: center;
  padding: 40px 0;

  .menu-item {
    width: 100px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 35px;
    border-radius: 8px;

    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
    .menu-icon {
      position: absolute;
      display: block;
      object-fit: contain;
      pointer-events: none;
    }

    .menu-icon-default {
      width: 69px;
      height: 69px;
      opacity: 1;
    }

    .menu-icon-active {
      width: 100px;
      height: 90px;
      margin-right: -30px;
      position: relative;
      top: 10px;
      opacity: 0;
    }

    // &:hover:not(.active) {
    //   background: rgba(255, 255, 255, 0.3);
    // }

    &.active {
      margin-right: 0;

      .menu-icon-default {
        opacity: 0;
      }

      .menu-icon-active {
        opacity: 1;
      }
    }
  }
}

.layout-content {
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: 22px 40px 22px 0;
  border-radius: 12px 0 0 0;
}
</style>
